"use strict";

exports.__esModule = true;
exports.getOptionValue = exports.getOptionLabel = void 0;

var getOptionLabel = function getOptionLabel(option) {
  return option ? option.label : '';
};

exports.getOptionLabel = getOptionLabel;

var getOptionValue = function getOptionValue(option) {
  return option ? option.value : '';
};

exports.getOptionValue = getOptionValue;